import { get, getOr, flow } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getViewItem = get('inventory.components.viewItem');

export const getActionOptions = createSelector(
  getViewItem,
  getOr([], 'actionOptions')
);

export const getItemAuditLogs = createSelector(
  getViewItem,
  getOr([], 'auditLogs')
);

export const getIsFetchingActionOptions = flow(
  getViewItem,
  get('fetchingActionOptions')
);

export const getIsFetchedActionOptions = flow(
  getViewItem,
  get('fetchedActionOptions')
);

export const getIsFetchingItemAuditLogs = flow(
  getViewItem,
  get('fetchingAuditLogs')
);

export const getIsFetchedItemAuditLogs = flow(
  getViewItem,
  get('fetchedAuditLogs')
);

export const getFetchingItemAuditLogsError = flow(
  getViewItem,
  get('fetchingAuditLogsError')
);
